import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';

// Vouch is a single-page cinematic landing. It follows tendra's route-per-screen shape
// with BrowserRouter, but there is exactly one screen; anything else redirects home.
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
